import { getFerootConfig, injectFerootScript } from './core/feroot-injector';
injectFerootScript(getFerootConfig());
export { ESWComponents as default } from './core/sdk-shell';

